<template>
<div class="float-e-margins ibox-content ibox_main">
	    <div class="form-horizontal">
		    <div class="form-group">
		   <!--表单查询开始-->
				<label class="col-sm-1 control-label">权限组名称</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model.trim="contacts" maxlength="20">
				</div>
				<label class="col-sm-2 control-label"></label>
				<div class="col-sm-7 text-right">
					<button class="btn btn-primary" @click="inquire">查询</button>
				</div>
			</div>
		</div>
		<!--表单查询结束-->
		<div class="hr-line-dashed"></div>
		<!--表格开始-->
		<table class="table mt20px table-striped table-bordered">
			<thead>
				<tr>
					<th></th>
					<th v-for="thead in theadList">{{thead}}</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(fileInfo,index) in dataTmp" v-bind:key="index">
					<td class="text-center"><input @click="selected(index)" type="checkbox"  :checked="dataTmp[index].isChecked"/></td>
					<td>{{fileInfo.roleName}}</td>
					<td>{{fileInfo.customerName}}</td>
					<td>{{fileInfo.resourceCount}}</td>
					<td>{{fileInfo.groupCount}}</td>
					<td>{{fileInfo.remark}}</td>
					<td class="text-center">
						<a @click="openDetail(index)">详情</a>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="form-horizontal">
		    <div class="form-group">
		         <div class="col-sm-12 text-center">
			        <button class="btn btn-primary" @click="certain">确定</button>
	  	         </div>
		    </div>
		</div>
		
		<sub-modal ref="modalMsgu" size="small" title="提示">
			<p v-text="tipContent"></p>	
			<div slot="footer">
				<button class="btn btn-primary" @click="closeMsgTip">确定</button>
			</div>
		</sub-modal>
		
	</div>
</template>
<script>
    import SubModal from 'components/common/SubModal'
	export default {
		name: "AddAuthorityGroup",
		components: {
			SubModal
		},
		props: {
			data: {
				default: function(){
					return [];
				},
				type: Array
			}
		},
		data() {
			return {
				showSubPage: false,
				dataArray:"",
				url: '../../../static/operator.json',
				listCount: 0, //一共多少条数据
				pageSize: 10, //默认每页显示10条数据
				showTable: false, //默认不加载分页组件，只有获取完ajax数据后才设为true
				orgList: [], //表格数据列表
				contacts: "", // 权限组名称
				theadList: ['权限组名称', '所属企业', '已授权功能数', '已授权分支', '备注'],
				queryResult: [], // 查询结果
				tipContent:'',
				dataTmp: [] // 为避免子组件内的查询操作改变props的data,故声明此中间变量以便随时切换指向data和queryResult
			};
		},
		watch: {
			'data'(val){
				this.dataTmp = val;
			}
		},
		methods: {
			openDetail(index){
				this.$emit("onDetail", index);
			},
			// 点击查询
			inquire(){
				if(!this.contacts){
					this.dataTmp = this.data;
				} else {
					this.queryResult = [];
					this.data.forEach((item) => {
						if(item.roleName.indexOf(this.contacts) >= 0){
							this.queryResult.push(item);
						}
						
					});
					this.dataTmp = this.queryResult;
					if(this.dataTmp.length==0){
					    this.openMsgTip("查询信息不存在");
					}
				}
			},
			getPageNo(pageNo) { //从分页组件获取页码参数
				//把分页参数传给后台，由后台返回新页码数据，再刷新页面
				this.param.pageNo = pageNo;
				window.location.reload(true); //刷新页面
			},
			removeItem(index) { //点击删除表格信息
				//把index传给后台，由后台删除（再前台删除）
				const startArr = this.orgList;
				startArr.splice(index, 1)
			},
			builtAuthority() { //点击新建权限组
				
			},
			selected(index){//选中某行事件触发
				this.dataTmp[index].isChecked = !this.dataTmp[index].isChecked;
			},
			certain() { //点击确定
                this.$emit('insertData');
			},
			openMsgTip(message) {
				this.tipContent = message
				this.$refs.modalMsgu.open();	
			},
			closeMsgTip() {
				this.$refs.modalMsgu.close();	
			},
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// AddAuthorityGroup.vue?20eee3a4